export const state = {
  // product: undefined,
  // products: []
  reseau: {},
  reseaux: [],
  pagination:''
}
